import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoggedInUserService } from '../auth/logged.in.user';
import { Configuration } from '../configuration';
import { GlobalHttpClient } from '../global.http.client';
import { IPage } from '../models/common/paging';
import { CreateStripePaymentIntentDto } from '../models/subscriptions/subscription.models';
import { BookingDto, TrainingCardPaymentDto, TrainingPaymentDto } from '../models/training/training.models';
import { TrainingSearchModel, TrainingSummaryDto } from '../models/training/training.search.models';
import { BaseService } from './base.service';
import { ISearchService } from './search.service';

@Injectable()
export class TrainingService extends BaseService implements ISearchService<TrainingSearchModel, TrainingSummaryDto> {
    constructor(http: GlobalHttpClient, private config: Configuration, private loggedInUserService: LoggedInUserService) {
        super(http);
    }

    search(request: TrainingSearchModel): Observable<IPage<TrainingSummaryDto>> {
        return this.http.getWithParams<IPage<TrainingSummaryDto>>('training/events', request);
    }

    getBookedEvents() {
        return this.http.get('training/bookedEvents');
    }

    getEvent(id: number) {
        return this.http.get(`training/events/${id}`);
    }

    getBooking(id: number) {
        return this.http.get(`training/bookings/${id}`);
    }

    getBookingForCustomer(dto: BookingDto) {
        return this.http.getWithParams('training/customerBookings', dto);
    }

    getPayment(id: number) {
        return this.http.get(`training/payments/${id}`);
    }

    book(dto: BookingDto) {
        return this.http.post('training/book', dto);
    }

    pay(dto: TrainingPaymentDto) {
        return this.http.post('training/pay', dto);
    }

    cardPay(dto: TrainingCardPaymentDto) {
        return this.http.post('training/cardPay', dto);
    }

    createPaymentIntent(request: CreateStripePaymentIntentDto) {
        var response = this.http.post('training/createPaymentIntent', request);

        return response;
    }

    downloadInvoice(id: number) {
        const invWindow = window.open();

        this.http.get(`training/invoiceToken/${id}`).subscribe((response: any) => {
            var token = response.token;

            var res = encodeURIComponent(encodeURIComponent(encodeURIComponent(token)));

            var url = `${this.config.routing.api.baseUrl}/training/invoice/${res}`;

            invWindow.location.href = url;
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/training.service.ts